import { ComponentType } from "@angular/cdk/portal";
import { Injectable } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { DialogConfirmarComponent } from "../../components/dialog-confirmar/dialog-confirmar.component";

@Injectable({
    providedIn: "root",
})
export class DialogService {
    constructor(private dialog: MatDialog) {}

    abrirDialog(
        dialog: ComponentType<unknown>,
        panelClass: string,
        width: string,
        data?: any,
        disableClose = false
    ): MatDialogRef<unknown, any> {
        return this.dialog.open(dialog, {
            panelClass,
            width,
            data,
            disableClose,
        });
    }

    abrirDialogConfirm(
        titulo: string,
        mensaje: string
    ): MatDialogRef<unknown, any> {
        return this.dialog.open(DialogConfirmarComponent, {
            panelClass: "clase-dialog",
            width: "600px",
            data: { titulo, mensaje },
            disableClose: true,
        });
    }
}
